import React from 'react';
import { render } from 'react-dom';
import './assets/semantic/semantic.min.css';
import './index.css';

// Components
import Routes from './api/Routes';


render(
  <Routes />,
  document.getElementById('root') // eslint-disable-line no-undef
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/